import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';

interface QuizResultByIdOptionsProps {
  id: number;
}

interface QuizAnswer {
  id: number;
  text: string;
  isCorrect: boolean;
}

interface QuizResultItem {
  questionId: number;
  questionText: string;
  userAnswerId: number;
  userAnswerText: string;
  isCorrect: boolean;
  correctAnswers: QuizAnswer[];
}

interface QuizResult {
  quizId: number;
  userId: number;
  correctAnswers: number;
  totalQuestions: number;
  score: number;
  results: QuizResultItem[];
}

export const quizResultByIdOptions = ({id}: QuizResultByIdOptionsProps) =>
  queryOptions({
    queryKey: ['quiz-result-by-id', id],
    queryFn: async (): Promise<QuizResult | null> => {
      try {
        const response = await api.get<QuizResult>(`/quizzes/results/${id}`);

        return response.data;
      } catch (error) {
        console.error('Failed to fetch action by id:', error);
        return null;
      }
    },
    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 1, // Только одна попытка повтора
  });
